import React from "react";

export default function MissionStatement() {
  return (
    <section
      data-testid="mission-section"
      className="relative bg-white"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-36">
        <div className="grid grid-cols-12 gap-8 md:gap-16">
          <div className="col-span-12 md:col-span-3">
            <div className="flex items-center gap-3 sticky top-28">
              <span className="brand-rule" />
              <span className="overline">Mission</span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-display font-black text-3xl md:text-5xl leading-[1.05] tracking-tight text-slate-900 max-w-3xl">
              We work the gap{" "}
              <span className="text-amber-600">before escalation</span> —
              influencing the environments that drive behavioral outcomes,
              not reacting to the crises they produce.
            </h2>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-3xl">
              <p className="text-slate-600 text-base md:text-lg leading-relaxed">
                MSWDC delivers <strong className="text-slate-900">Animal-Assisted Environmental
                Stabilization Support</strong> — a structured, doctrine-led practice that uses
                trained canine-handler teams to reduce tension, restore staff capacity, and
                interrupt early escalation signals across complex human systems.
              </p>
              <p className="text-slate-600 text-base md:text-lg leading-relaxed">
                We are explicitly <strong className="text-slate-900">non-clinical</strong>.
                We do not replace therapists, counselors, or behavioral specialists. We
                stabilize the room they work in — enhancing the conditions that allow other
                care to succeed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
